module.exports = __webpack_public_path__ + "img/uid.a9bd2045.png";